import { render, staticRenderFns } from "./ProjectorInfo.vue?vue&type=template&id=3ad7b816&scoped=true&"
import script from "./ProjectorInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectorInfo.vue?vue&type=style&index=0&id=3ad7b816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7b816",
  null
  
)

export default component.exports